export default __webpack_public_path__ + "static/media/item_5_active.6d5a1e98.png";